import {EPBorderType, EPMethod, ProductCustomizationState} from '../../../product/rendering/render.def';

const hasText = (value: unknown): boolean => typeof value === 'string' && value.trim() !== '';

// Same cases as the product renderer's getRailBottomForDynamicEP: the bottom rail grows by the
// plate face so the mat above and below the plate is about half a rail, not a sliver.
const plateNeedsTallerBottomRail = (pcs: ProductCustomizationState): boolean => {
    const method = pcs.EPMethodID;

    if (method === EPMethod.Extended) {
        const hasLine = [pcs.EP_1, pcs.EP_2, pcs.EP_3, pcs.EP_4, pcs.EP_5, pcs.EP_6, pcs.EP_7, pcs.EP_8, pcs.EP_9, pcs.EP_10].some(hasText);

        return hasLine || hasText(pcs.EPContent);
    }

    if (method === EPMethod.Custom || method === EPMethod.Admin || method === EPMethod.Template) {
        return true;
    }

    return pcs.EPBorderType === EPBorderType.InnerAccent && method !== EPMethod.SingleDoc;
};

const plateFaceInches = (pcs: ProductCustomizationState): number => {
    const dpi = pcs.DPI > 0 ? pcs.DPI : 0;
    const facePx = parseFloat(pcs.css?.ep_height ?? '');

    if (dpi > 0 && Number.isFinite(facePx) && facePx > 0) {
        return facePx / dpi;
    }

    if (pcs.EPMethodID === EPMethod.Old) {
        return 1.3;
    }

    return pcs.EPHeight > 0 ? pcs.EPHeight : 0;
};

/** Bottom rail for this frame. Unchanged when the product renderer would not lengthen it. */
export const plateBottomRailInches = (railBottomInches: number, pcs: ProductCustomizationState): number => {
    if (!(railBottomInches > 0) || !pcs.css?.ep_visible || !plateNeedsTallerBottomRail(pcs)) {
        return railBottomInches;
    }

    const extra = plateFaceInches(pcs);

    return extra > 0 ? railBottomInches + extra : railBottomInches;
};
